import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import useGetCompanyPathTo from 'pages/companies/hooks/useGetCompanyPathTo';

import Link from '@mui/material/Link';
import RouterLink from 'components/mui/Router/RouterLink';

const NameCell: React.FC<ICellRendererParams> = ({ value, valueFormatted, data }) => {
  const href = useGetCompanyPathTo(data?.name || value, data?.id);

  return (
    <Link component={RouterLink} to={href} underline="hover">
      {valueFormatted}
    </Link>
  );
};

export default NameCell;
